import React from "react"
import ReactDOM from "react-dom/client"
import "./styles/globals.css"
import "./styles/normalize.css"
import { BrowserRouter as Router } from "react-router-dom"
import App from "./App"
import { AuthProvider } from "./context/AuthContext"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Router>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
